'use client';

import { OrganizationProfileSection } from '../../components/OrganizationProfile/OrganizationGeneralPage';
import { createSection } from '../createSection';

export const OrganizationProfileProfileSection = createSection(
  'OrganizationProfileProfileSection',
  OrganizationProfileSection,
);
